import { useLocation, useNavigate } from "react-router-dom";

// components imports
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import ICONS from "../../../../assets/Icons";
import IfscCodeMapper from "../../../../components/_utils/IfscLogoMapper";
import TickerAnimation from "../../../../components/_utils/TickerAnimation";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import CommonToast from "../../../../components/_utils/CommonToast";
import CardActionableButton from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";

const InternalViewAllCard = ({
  id,
  data,
  isSidebarOpen,
  type,
  typepop,
  handleButtonClick,
  associateAccount,
  associateTxn,
  setOpenBeneAssociate,
  beneAccountId,
  txnPayLoad,
  scheduleIntenralTxn,
  isLabelClicked,
  setLabelAccounts,
  LabelAccounts,
  setlableInput,
  Labeldata,
  setLabeldata,
  filterRef,
  onCardNavigate,
  setIsalertPopup,
  setFlowSelectedId,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  const isInvalidStatus = (status) =>
    ["blocked", "archived", "rejected"].includes(status);

  const isSameAccount = (account) =>
    txnPayLoad?.ownerBankAccountNo === account?.bank_acc_no &&
    txnPayLoad?.ownerBankIFSC === account?.ifsc_code &&
    txnPayLoad?.ownerPan === account?.pan_no;

  const toggleSelection = (account) => {
    if (Array.isArray(LabelAccounts) && LabelAccounts.includes(account.id)) {
      setLabelAccounts(LabelAccounts.filter((id) => id !== account.id));
    } else {
      setLabelAccounts([...LabelAccounts, account.id]);
      setLabeldata([...Labeldata, account]);
    }
    setlableInput(false);
  };

  return (
    <div
      style={{
        overflowY: isSidebarOpen ? "hidden" : "",
        zIndex: typepop === "popup" && "var(--z-index-content)",
      }}
      className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md ${
        isSidebarOpen ? "sidebar-open" : ""
      } ${
        data?.filter((item) => item.id !== beneAccountId).length ===
        GlobalConfiguration.lengthCheckZero
          ? "!flex flex-1 items-center justify-center"
          : ""
      }`}
    >
      {data?.filter((item) => item.id !== beneAccountId).length >
      GlobalConfiguration.lengthCheckZero ? (
        data
          ?.filter((item) => item.id !== beneAccountId)
          .map((account) => {
            const redirectUrl = `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${account.id}`;
            const getFormattedName = (name = "") =>
              name
                .toLowerCase()
                .split(" ")
                .map((word) =>
                  word ? word.charAt(0).toUpperCase() + word.slice(1) : "",
                )
                .join(" ");
            const labelsText = account?.labels?.length
              ? account.labels.join(", ")
              : "Not assigned";
            return (
              <CardContainer
                key={account.id}
                hoverHeight={GlobalConfiguration.beneAccountCardHoverHeight}
                filterRef={filterRef}
                minHeight={GlobalConfiguration.BeneAccCardMinHeight}
                context={account}
                isSelected={
                  Array.isArray(LabelAccounts) &&
                  LabelAccounts.includes(account.id)
                }
                isDisabled={
                  account.id === id ||
                  (isLabelClicked && account?.approval_status === "archived") ||
                  (!(
                    associateAccount ||
                    (associateTxn === "associateTxn" &&
                      isInvalidStatus(account?.approval_status))
                  ) &&
                    typepop === "popup" &&
                    isInvalidStatus(account?.approval_status)) ||
                  (typepop === "popup" &&
                    !isInvalidStatus(account?.approval_status) &&
                    isSameAccount(account))
                }
                onClickHandler={(e) => {
                  // Active/Inactive flow
                  if (type === "activeInactive") {
                    setIsalertPopup?.(true);
                    setFlowSelectedId?.(account?.id);
                    return;
                  }

                  // Popup logic
                  if (typepop === "popup") {
                    if (
                      scheduleIntenralTxn &&
                      (isInvalidStatus(account?.approval_status) ||
                        isSameAccount(account))
                    ) {
                      CommonToast({
                        text: "Destination account cannot be same as source account.",
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                        buttonNeeded: false,
                      });
                      return;
                    }

                    if (
                      isInvalidStatus(account?.approval_status) &&
                      !associateAccount
                    ) {
                      if (isLabelClicked) {
                        toggleSelection(account);
                      }
                      return;
                    }

                    if (isLabelClicked) {
                      toggleSelection(account);
                      return;
                    }

                    if (e?.stopPropagation) e.stopPropagation();
                    handleButtonClick(account);
                    return;
                  }

                  if (isLabelClicked) {
                    toggleSelection(account);
                    return;
                  }

                  if (!isSidebarOpen) {
                    if (associateAccount) {
                      setOpenBeneAssociate?.(false);
                    }
                    if (onCardNavigate) {
                      onCardNavigate(redirectUrl);
                    } else {
                      navigate(redirectUrl, {
                        replace: true,
                        state: {
                          isViewAll:
                            location.pathname ===
                            "/internal_account_dashboard/internal_account_view_all",
                        },
                      });
                    }
                  }
                }}
              >
                <card-body>
                  <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                    <div className="w-full flex justify-between items-center">
                      <p
                        className="text-font-sm flex-1 truncate font-normal"
                        style={{
                          color: "var(--text-primary)",
                        }}
                      >
                        <TickerAnimation
                          text={getFormattedName(account?.name) || "N/A"}
                        />
                      </p>

                      <div
                        className="gap-x-gap-sm ml-margin-sm justify-end"
                        style={{ display: "flex" }}
                      >
                        {isLabelClicked && (
                          <CardActionableButton
                            icon={
                              Array.isArray(LabelAccounts) &&
                              LabelAccounts.includes(account.id)
                                ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                            }
                            isDisabled={false}
                          />
                        )}
                      </div>
                    </div>

                    <p className="text-font-xs transform-none text-text-secondary">
                      Account name
                    </p>
                  </div>
                  <div className="flex gap-x-gap-sm justify-between items-center">
                    <div className="flex flex-1 truncate flex-col gap-y-gap-xs">
                      <p className="text-font-sm text-text-primary flex-1 truncate font-normal pl-padding-sm">
                        <TickerAnimation
                          text={formatAccountNumber(account.bank_acc_no)}
                        />
                      </p>

                      <p className="text-font-xs text-text-secondary pl-padding-sm">
                        Account number
                      </p>
                    </div>

                    <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-l-border-radius-md py-padding-xs px-padding-sm">
                      <div className="w-banklogo-width-sm h-icon-xs flex-shrink-0">
                        <IfscCodeMapper ifscCode={account?.ifsc_code} />
                      </div>
                    </div>
                  </div>
                </card-body>

                <card-hover>
                  <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                    <div className="w-full flex justify-between items-center">
                      <p
                        className="text-font-sm flex-1 truncate font-semibold"
                        style={{
                          textTransform: "capitalize",
                          color: getStatusColor(account?.approval_status),
                        }}
                      >
                        {account?.approval_status || "N/A"}
                      </p>
                    </div>

                    <p className="text-font-xs transform-none text-text-secondary">
                      Account status
                    </p>
                  </div>

                  <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                    <div className="w-full flex justify-between items-center">
                      <p
                        className="text-font-sm flex-1 truncate font-normal"
                        style={{
                          color: "var(--text-primary)",
                        }}
                      >
                        <TickerAnimation text={labelsText} />
                      </p>

                      <div
                        className="gap-x-gap-sm ml-margin-sm justify-end"
                        style={{ display: "flex" }}
                      >
                        <CardActionableButton
                          icon="https://q2pay.in/new_assets/common/view_all/label.svg"
                          isDisabled={undefined}
                        />
                      </div>
                    </div>
                  </div>
                </card-hover>
              </CardContainer>
            );
          })
      ) : (
        <div className="flex flex-col items-center justify-center m-auto w-full h-full">
          <img
            src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
            alt="No accounts found"
            className="opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
          />
          <p className="text-text-primary">No data found.</p>
        </div>
      )}
    </div>
  );
};

export default InternalViewAllCard;
